var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',[(_vm.checkPermission())?_c('TabPanel',{attrs:{"header":"ข้อมูลระดับสิทธิ์"}},[_c('admin-permission')],1):_vm._e(),_c('TabPanel',{attrs:{"header":"ข้อมูลผู้ใช้งานระบบ"}},[_c('admin-user')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }